export default __webpack_public_path__ + "static/media/rdstation-negative.0d566b01.svg";